export default class cityModel {
  constructor(item = {}) {
    this.ID = item.id
    this.name = item.name
  }
}

export class CityWithAdditionalInfoModel extends cityModel{
  constructor(item = {}) {
    super(item)
    this.top_cbr_queue_count = item.top_cbr_queue_count;
    this.city_exams = item.city_exams
  }
}